import { CulturalTopicName, TechnicalTopicName } from './categories.types';

export enum EvaluatorToEvaluateeRole {
    SELF = 'SELF',
    PEER__PEER = 'PEER__PEER',
    TECH_LEAD__MEMBER = 'TECH_LEAD__MEMBER',
    MEMBER__TECH_LEAD = 'MEMBER__TECH_LEAD',
    MANAGER__MEMBER = 'MANAGER__MEMBER',
    MEMBER__MANAGER = 'MEMBER__MANAGER',
    STAKEHOLDER__MEMBER = 'STAKEHOLDER__MEMBER',
}

export type RoleParts = {
    evaluator: string;
    evaluatee: string;
};

export type EvaluatorImpact = Record<EvaluatorToEvaluateeRole, number>;

export type TechnicalEvaluatorImpact = {
    category: TechnicalTopicName;
    impact: EvaluatorImpact;
};

export type CulturalEvaluatorImpact = {
    category: CulturalTopicName;
    impact: EvaluatorImpact;
};
